<template>
  <div>
    <Dropdown class="m-0">
      <div slot="toggle">
        <div
          class="text-gray-900 hover:bg-gray-100 px-2 py-1 md:py-2 rounded-md cursor-pointer"
          data-test-id="toggle-cta"
        >
          <Icon name="share" class="ds-text-base" />
          <span v-if="isDesktop" class="ds-text-base" data-test-id="share-label"> Share</span>
        </div>
      </div>
      <div slot="content" class="ds-text-sm" data-test-id="content">
        <DropdownActionItem
          v-if="canShare && !isMobileApp"
          class="flex items-center"
          data-test-id="x-share-link"
          @click="xShareClick"
        >
          <Icon name="twitter" class="mr-1" />
          Share on X
        </DropdownActionItem>
        <DropdownActionItem
          v-if="canShare && !isMobileApp"
          class="flex items-center"
          data-test-id="facebook-share-link"
          @click="facebookShareClick"
        >
          <Icon name="facebook" class="mr-1" />
          Share on Facebook
        </DropdownActionItem>
        <DropdownActionItem class="flex items-center" data-test-id="copy-link" @click="copyProfileLink">
          <Icon name="link" class="mr-1" />
          Copy profile link
        </DropdownActionItem>
      </div>
    </Dropdown>
    <Portal to="flash-alert">
      <div
        v-if="showAlert"
        class="z-1000 fixed right-3 left-3 xs:right-3 xs:left-auto"
        :class="{
          'bottom-3': !isLoggedOut,
          'bottom-70px': isLoggedOut
        }"
      >
        <FlashAlert
          ref="flashAlert"
          type="success"
          :persistent="false"
          message="Link Copied"
          @flash-alert-dismissed="showAlert = false"
        />
      </div>
    </Portal>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from "vuex";
import { Dropdown, DropdownActionItem, FlashAlert, Icon } from "@sportsrecruits/playbook"
import SRCookies from '@/services/cookies'
export default defineComponent({
  name: "ShareDropdown",
  components: {
    Dropdown,
    DropdownActionItem,
    FlashAlert,
    Icon,
  },
  props: {
    athleteFullName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("userData", ["isLoggedOut"]),
    ...mapGetters("athleteProfile", ["canShare"]),
    facebookShareLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.athleteURL}`;
    },
    twitterShareLink() {
      return `https://x.com/share?url=${this.athleteURL}&text=${this.text}`;
    },
    athleteURL() {
      return window.location.href
    },
    text() {
      return `Check out ${this.athleteFullName}'s profile on ${this.siteName}:`
    },
    siteName() {
      return this.$domain.config('title_name', 'SportsRecruits')
    },
    isDesktop() {
      return !["xs", "sm", "mobile"].includes(this.$mq);
    },
    isMobileApp() {
      return SRCookies.isMobileSession()
    },
  },
  methods: {
    copyProfileLink() {
      const url = window.location.href;
      navigator.clipboard.writeText(url);
      this.hideDropdown()
      this.showAlert = true;
    },
    xShareClick() {
      window.open(this.twitterShareLink, '_blank').focus();
      this.hideDropdown()
    },
    facebookShareClick() {
      window.open(this.facebookShareLink, '_blank').focus();
      this.hideDropdown()
    },
    hideDropdown() {
      document.body.click();
    },
  },
})
</script>

<style scoped>
.bottom-70px {
  bottom: 70px;
}
</style>